// extracted by mini-css-extract-plugin
export default {"livesDisplay":"LivesDisplay_livesDisplay__4OWR4","livesText":"LivesDisplay_livesText__-WjEu"};